var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.data.id}},[_vm._v(_vm._s(_vm.data.id))])
}
var staticRenderFns = []

export { render, staticRenderFns }